<ng-content select="[data-leading]">
  @if (leading()) {
    <span data-leading>{{ leading() }}</span>
  }
</ng-content>

@if (mask()) {
  <input [attr.aria-label]="label()"
         [disabled]="disabled() || disabledState()"
         [dropSpecialCharacters]="mask()?.dropSpecialCharacters"
         [id]="controlId()"
         [mask]="mask()?.mask"
         [patterns]="mask()?.patterns"
         [placeholder]="placeholder() || ''"
         [readOnly]="readOnly() || null"
         [required]="required() || null"
         [type]="type()"
         [value]="value()"
         (blur)="handleBlur($event)"
         (change)="change.emit($event)"
         (input)="handleInput($event)"
  >
}
@else {
  <input [attr.aria-invalid]="invalid()"
         [attr.aria-label]="label()"
         [attr.data-invalid]="invalid()"
         [disabled]="disabled() || disabledState()"
         [id]="controlId()"
         [placeholder]="placeholder() || ''"
         [readOnly]="readOnly() || null"
         [required]="required() || null"
         [type]="type()"
         [value]="value()"
         (blur)="handleBlur($event)"
         (change)="change.emit($event)"
         (input)="handleInput($event)"
  >
}

<ng-content select="[data-trailing]">
  @if (trailing()) {
    <span data-trailing>{{ trailing() }}</span>
  }
</ng-content>
